export default __webpack_public_path__ + "static/media/house-guard.6bb1c632.svg";